import { L3_PATHS } from 'Deer/constants/routes';
import { useRouteToMyTeamLevels } from 'Deer/hooks/useRouteToL3';
import { matchPath, useLocation } from 'react-router-dom';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { routes } from 'constants/routes';

interface IUseOneOnOnePageParams {
  masterId: string;
  instanceId: string;
}

const useOneOnOnePageParams = () => {
  const { teamType } = useRouteToMyTeamLevels();
  const location = useLocation();
  let path;
  if (teamType === 'directReports') {
    path = L3_PATHS.team.directReports.oneOnOne.instancePage;
  } else if (teamType === 'allReports') {
    path = L3_PATHS.team.allReports.oneOnOne.instancePage;
  } else {
    path = L3_PATHS['my-data'].oneOnOne.instancePage;
  }

  const { params } =
    matchPath<IUseOneOnOnePageParams>(location.pathname, {
      path: checkNewNavEnabled() ? path : routes.oneOnOne.instanceRabbit,
      exact: true,
    }) ?? {};
  const { masterId, instanceId } = params ?? {};

  return {
    masterId: Number(masterId),
    instanceId: Number(instanceId),
  };
};

export default useOneOnOnePageParams;
